import { DayOfWeek } from "@/types/enums.type";

const formatDate = function(date: string, options?: Intl.DateTimeFormatOptions): string {
  let dateFormatOptions: Intl.DateTimeFormatOptions = {
    weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'
  } 

  if (options) {
    dateFormatOptions = options;
  }

  return new Date(date).toLocaleDateString(undefined, dateFormatOptions)
};

const getDateFromIsoDate = function(date: string): Date {
  const [year, month, day] = date.split("-").map(Number);

  return new Date(year, month - 1, day);
}

const getDatesFromIsoDate = function(dates: string[]): Date[] {
  return dates.map(date => getDateFromIsoDate(date));
}

const getCurrentIsoDate = function(): string {
  return new Date().toISOString().split("T")[0];
}

const getWeekDayEnum = function(date: Date): DayOfWeek {
  const day = date.getDay();

  return (day + 1) as DayOfWeek;
}

export {
  formatDate,
  getDateFromIsoDate,
  getDatesFromIsoDate,
  getCurrentIsoDate,
  getWeekDayEnum
};